import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Hide(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.646 5.354l14 14 .708-.707-2.737-2.737C19.816 14.44 22 12 22 12s-4.477-5-10-5c-1.275 0-2.495.267-3.616.677l-3.03-3.03-.708.707zm4.525 3.11l.376.376a4 4 0 015.613 5.613l.7.7a15.096 15.096 0 002.643-1.476 18.494 18.494 0 002.032-1.63l.05-.047-.05-.048a18.493 18.493 0 00-2.032-1.63C16.769 9.126 14.47 8 12 8c-.978 0-1.93.176-2.83.464zm5.274 5.274a3 3 0 00-4.184-4.184l1.48 1.48a1 1 0 011.225 1.225l1.48 1.48z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.09 14.796l.754.755a4 4 0 01-5.394-5.394l.754.754a3 3 0 003.885 3.885z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.497 13.677C7.231 14.875 9.53 16 12 16c.699 0 1.384-.09 2.046-.246l.818.817c-.907.267-1.869.429-2.864.429-5.523 0-10-5-10-5s1.883-2.102 4.712-3.58l.744.743c-.708.35-1.367.75-1.959 1.16a18.49 18.49 0 00-2.032 1.63l-.05.047.05.048a18.49 18.49 0 002.032 1.63z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Hide);
export default ForwardRef;